import AnchorLink from "react-anchor-link-smooth-scroll";
import { Link } from "gatsby";
import * as React from 'react';
export default {
  AnchorLink,
  Link,
  React
};